import React, { Component } from 'react';
import Page from '../../containers/page';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import {
    Label, Input, Button
} from 'reactstrap';
import {getSearchParams} from "../../helpers/link";
import moment from "moment/moment";

class Home extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            total: 10,
            customerId: null,
            sku: '',
            items: [],

        }
    }


    componentDidMount() {
        this.setState({
            total: 10,
            customerId: null,
            sku: '',
            items: [],

        })
        this.updateMultipleParams([{'sku': '' }, {'customerId': ''}],  true);

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            const newParams = getSearchParams(this.props[0].location.search)
            const oldParams = getSearchParams(prevProps[0].location.search)
            if(!newParams.customerId) {
                this.setState({
                    items: []
                })
                this.setState({
                    total: 0
                })
                return
            }
            if(newParams.entries !== oldParams.entries || newParams.page !== oldParams.page) {
                this._api('search', getSearchParams(this.props[0].location.search, {entries: 10, page: 0}),  (data) => {
                    this.setState(data)
                });
            }
        }
    }



    render() {
        let params = this._getParams();

        console.log(this.state.categories)
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Price list'.translate(this.props.lang)}</h1>

                </div>
                <div>
                    <Label className="mr-3">
                        {'Customer'.translate(this.props.lang)}
                        <Input value={this.state.customerId} onInput={(val) => {
                            this.setState({customerId: val.target.value})
                            this.updateParams('customerId',  val.target.value, true);
                            if(val.target.value) {
                                this.setState({valid: true})
                            } else {
                                this.setState({valid: false})
                            }

                        }} style={{minWidth: 200}} type="text" className="entries"/>
                    </Label>
                    <Label className="mr-3">
                        {'SKU'.translate(this.props.lang)}
                        <Input value={this.state.sku} onInput={(val) => {
                            this.setState({sku: val.target.value})
                            this.updateParams('sku',  val.target.value, true);
                        }} style={{minWidth: 200}} type="text" className="entries"/>

                    </Label>
                    <Button disabled={!this.state.valid} onClick={() => {

                        this.updateParams('page',  0, true);
                        this._api('search', getSearchParams(this.props[0].location.search, {entries: 10, page: 0}),  (data) => {
                            this.setState(data)
                        });
                    }}>SEARCH</Button>
                </div>
                <div>
                    <ListBuilder
                        tabs={false}
                                sort={true}
                                hideFilters={true}
                                hideResults={true}

                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={true}
                                fields={[
                                    { type: 'text', name: '_id', label: 'ID'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'sku', label: 'SKU'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'price', label: 'PRICE'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'vatPercent', label: 'VAR PERCENT'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'currency', label: 'CURRENCY'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'salesUnit', label: 'SALES UNIT'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'tsModified', label: 'MODIFIED'.translate(this.props.lang), multilang: false, allowSort: false },
                                    { type: 'text', name: 'tsCreated', label: 'CREATED'.translate(this.props.lang), multilang: false, allowSort: false },


                                ]}

                                items={this.state.items.map((item) => {
                                    return {
                                        ...item,
                                        tsModified: item.tsModified ? `${moment.unix(item.tsModified).format('YYYY-MM-DD HH:MM:ss')}` : '',
                                        tsCreated: item.tsCreated ? `${moment.unix(item.tsCreated).format('YYYY-MM-DD HH:MM:ss')}` : '',

                                    }
                                })}
                                params={params}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>



            </div>
        )
    }
}

export default Page(Home);

/*

*/
